import debounce from 'lodash/debounce';
import React, {useEffect, useMemo} from 'react';

import {SearchInput} from '@albert-io/atomic';

interface ClassworkFilterBarProps {
  searchPlaceholder: string;
  search: string;
  onSearchChange: (value: string) => void;
  onDebouncedSearchChange: (value: string) => void;
  /** Filter/sort controls, rendered right-aligned (StatusDropdown, ClassesDropdown, etc.). */
  children: React.ReactNode;
}

export const ClassworkFilterBar = ({
  searchPlaceholder,
  search,
  onSearchChange,
  onDebouncedSearchChange,
  children
}: ClassworkFilterBarProps) => {
  const debouncedSearchChange = useMemo(
    () => debounce(onDebouncedSearchChange, 200),
    [onDebouncedSearchChange]
  );
  useEffect(() => () => debouncedSearchChange.cancel(), [debouncedSearchChange]);

  return (
    <div className='flex flex-wrap items-center justify-between gap-x2'>
      <SearchInput
        className='w-[clamp(280px,33%,480px)]'
        rectangle
        placeholder={searchPlaceholder}
        value={search}
        onChange={(_e, value) => {
          onSearchChange(value);
          debouncedSearchChange(value);
        }}
        onReset={() => {
          onSearchChange('');
          debouncedSearchChange.cancel();
          onDebouncedSearchChange('');
        }}
      />
      <div className='flex flex-wrap items-center gap-x1'>{children}</div>
    </div>
  );
};
